export const rendererWheelThrottlingTimeout = 75;

export const minCanvasSize = 1;

export const maxCanvasSize = 5000;
